import React from 'react';
import { Planet } from 'react-kawaii';
import styled from 'styled-components';

const StyledError = styled.div`
	text-align: center;
	padding: 5rem 0;

	svg {
		opacity: 0.5;
	}

	div {
		max-width: 32rem;
		margin: 1.5rem auto;
	}
`;

const ApartmentsListError = () => (
	<StyledError>
		<Planet size={220} mood="shocked" color="#f0f0f0" />
		<div>Eitthvað fór úrskeiðis, tókst ekki að sækja leiguíbúðir...</div>
	</StyledError>
);

export default ApartmentsListError;
